module.exports = require('./helpers/bundle-url').getBundleURL('8SseS') + "global-error-image.c1b47184.svg";